import { useMutation } from '@tanstack/react-query';
import dataService from 'services/dataService';
import { API_UPDATE_UNTRACKED_CALL } from 'services/dataService/resources/callManagement/constants';
import { notificationController } from 'infrastructure/antd/controllers/notification-controller';
import { useTranslation } from 'react-i18next';

import type { AssignCallRequest } from './types';

interface UseAssignCallProps {
  onSuccess?: () => void;
}

export const useAssignCall = ({
  onSuccess,
}: UseAssignCallProps | undefined = {}) => {
  const { t } = useTranslation();

  const { mutate, isLoading } = useMutation({
    mutationFn: (callToAssign: AssignCallRequest) => {
      return assignCall(callToAssign);
    },
    onSuccess: (data) => {
      if (data?.response) {
        notificationController.success({
          message: data.response,
        });
      }
      onSuccess?.();
    },
    onError: (error) => {
      let message = t('labels.somethingWentWrong');
      if (error instanceof Error) {
        message = error.message;
      }
      notificationController.error({
        message,
      });
    },
  });

  return {
    mutate,
    isLoading,
  };
};

const assignCall = async (callToAssign: AssignCallRequest) => {
  const url = API_UPDATE_UNTRACKED_CALL(callToAssign.callId);
  const { error, data } = await dataService.updateOnly<{ response: string }>(
    url,
    {
      guid: callToAssign.guid,
      type: callToAssign.type,
    },
  );
  if (error) {
    throw new Error(error);
  }
  if (!data) {
    return undefined;
  }
  return {
    response: data.response,
  };
};
